













































import { Component, Vue } from "vue-property-decorator";
import {
  Filter,
  FilterOption,
  ValueType,
  WhereOption,
} from "../../models/filter";

@Component
export default class AddFilter extends Vue {
  activeFilterOption: FilterOption | null = null;

  activeWhere: WhereOption | null = null;

  filterOptions: FilterOption[] = [
    new FilterOption("make", "Make", ValueType.String, [
      WhereOption.contains,
      WhereOption.exists,
      WhereOption.matchesExactly,
      WhereOption.notExists,
    ]),
    new FilterOption("model", "Model", ValueType.String, [
      WhereOption.contains,
      WhereOption.exists,
      WhereOption.matchesExactly,
      WhereOption.notExists,
    ]),
    new FilterOption("imageUrl", "Photo", ValueType.String, [
      WhereOption.exists,
      WhereOption.notExists,
    ]),
    new FilterOption("vin", "VIN", ValueType.String, [
      WhereOption.contains,
      WhereOption.matchesExactly,
    ]),
    new FilterOption("year", "Year", ValueType.Number, [
      WhereOption.exists,
      WhereOption.matchesExactly,
      WhereOption.notExists,
    ]),
  ];

  value: string | number | null = null;

  get filter(): Filter | null {
    if (!this.activeFilterOption || !this.activeWhere) {
      return null;
    }

    return new Filter(
      this.activeFilterOption.key,
      this.activeFilterOption.label,
      this.activeWhere,
      this.value,
      this.activeFilterOption.type
    );
  }

  get filterSelected(): boolean {
    return !!this.activeFilterOption;
  }

  get needsValueInput(): boolean {
    return !!this.activeWhere && this.activeWhere.needsValue;
  }

  get readyToAdd(): boolean {
    if (!this.activeFilterOption || !this.activeWhere) {
      return false;
    }

    if (!this.needsValueInput) {
      return true;
    }

    return !!this.value;
  }

  get valueType(): string {
    if (!this.activeFilterOption || !this.activeWhere) {
      return ValueType.None;
    }
    return this.activeFilterOption.type;
  }

  get whereOptions(): WhereOption[] {
    if (!this.activeFilterOption) {
      return [];
    }

    return this.activeFilterOption.where;
  }

  addFilter() {
    if (!this.readyToAdd) {
      return;
    }
    this.$emit("add-filter", this.filter);
    this.clear();
  }

  clear() {
    this.activeFilterOption = null;
    this.activeWhere = null;
    this.value = null;
  }
}
